<div class="rfq-product-substitution p-5">
  <h3 class="mb-5">Product Substitutes</h3>
  <mat-divider class="mb-5 mt-2"></mat-divider>
  <div class="row mt-3 mb-3 d-flex align-items-center">
    <div class="col-3">
      <input
        type="text"
        class="lum-input m-input-filter"
        [(ngModel)]="searchTerm"
        placeholder="Filter Table"
      />
    </div>
    <div class="col-3">
      <lum-rfq-list-dropdown
        placeholder="Search And Select SKU"
        (selectOptionEvent)="onSelectEvent($event)"
        #searchSelectComponent
      ></lum-rfq-list-dropdown>
    </div>
    <div class="col-2">
      <button
        (click)="onAdd()"
        class="lum-button lum-button--primary lum-button--large"
        [disabled]="submittingForm === true"
      >
        <i class="fas fa-spinner fa-spin" *ngIf="submittingForm === true"></i> Add
        Product Substitute
      </button>
    </div>
  </div>

  <ng-container *ngIf="loading === false">
    <lum-rfq-product-substitution-table
      *ngIf="currentProductSubstitutions?.length; else empty"
      [productSubstitutions]="filteredTableData"
      (detachEvent)="onDetachEvent($event)"
      (dropEvent)="onDropEvent($event)"
    ></lum-rfq-product-substitution-table>
  </ng-container>

  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>

  <ng-template #empty>
    <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
  </ng-template>
</div>
